import React, { Component } from 'react';
import Layout from "../Layout";

import { Select, Button, Input, Textarea } from "~/js/partials";
import { isInitialValid, processRegions, processMakes, groupBrands, processModels, groupDealerships, formatGroupLabel } from "~/js/utils";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { formsService } from '~/js/_services';
import { favouritesService } from '~/js/_services';
import Turnstile from "react-turnstile";
import {addEmailPhoneDatalayer} from "../../../utils";

const vehicle = window.current_vehicle ?? null;
const dealer = window.current_dealer ?? null;

const filterDealers = window.filter_dealership_forms ?? null;

const currentBrand = window.current_brand ?? null;

let brands = Object.values(window.brands_data);
const otherBrands = Object.values(window.otherBrands_data);
let currentBrands = (window.current_brands);

if(currentBrands == null){
    currentBrands = false;
}else{
    const slugs = new Set(currentBrands.map(item => item.slug));
    brands.filter(item => slugs.has(item.post_name));
}


// const combinedBrands = [...brands, ...otherBrands];
// const dropDownBrands = processMakesById(combinedBrands);

const dropDownBrands = groupBrands(brands, currentBrands ? [] : otherBrands, "Select Brand");

let dropDownOfferBrands = dropDownBrands;
if (currentBrands && currentBrands.length > 0) {
    dropDownOfferBrands = [];
    brands.forEach((element) => {
        if (currentBrands.filter(e => e.id == element.ID).length > 0) {
            dropDownOfferBrands.push(element);
            /* vendors contains the element we're looking for */
        }
    })
    dropDownOfferBrands = (groupBrands(dropDownOfferBrands, currentBrands ? [] : otherBrands, "Select Brand"));

}

let dealershipsGrouped = [];
class FormMakeAnEnquiry extends Component {

    state = {
        formDealerID: null,
        dealership: null,
        dealerships: dealershipsGrouped,
        makeID: null,
        selectedBrand: null,
        turnstileToken : "",

    };
    decodeHtmlEntities(str) {
        const txt = document.createElement("textarea");
        txt.innerHTML = str;
        return txt.value;
    }

    componentDidMount() {
        if(filterDealers && filterDealers.length > 0) {
            dealershipsGrouped = groupDealerships(this.props.regions, "");
            const filterDealerNames = new Set(filterDealers.map(item => this.decodeHtmlEntities(item.name)));
            dealershipsGrouped.forEach((element) => {
                if (element.options) {
                    element.options = element.options.filter(item => filterDealerNames.has(this.decodeHtmlEntities(item.value)));
                }
            })
            const locationWithOptions = dealershipsGrouped.findIndex(location => location.options.length > 0);

            if(locationWithOptions >= 0){
                this.setState(
                    {
                        formDealerID: dealershipsGrouped[locationWithOptions]['options'][0]['dealer']['ID'],
                        dealership: dealershipsGrouped[locationWithOptions]['options'][0]['dealer']['post_title']
                    },
                    () => {
                    }
                );
                if (this.formik) this.formik.setFieldValue('dealership',dealershipsGrouped[locationWithOptions]['options'][0]['dealer']['post_title']);
                if (this.formik) this.formik.setFieldValue('formDealerID',dealershipsGrouped[locationWithOptions]['options'][0]['dealer']['ID']);

            }

            const allOptionsEmpty = dealershipsGrouped.every(dealership =>
                !dealership.options || dealership.options.length === 0
            );
            if (allOptionsEmpty) {
                dealershipsGrouped = groupDealerships(this.props.regions);
            }
        }else{
            dealershipsGrouped = groupDealerships(this.props.regions);
        }


        this.favouritesSubscription = favouritesService.current.subscribe(f => {
            this.setState({
                favourites: f,
            })
        });
        this.checkForm();
        this.updateDealers();
        this.prefillParams();




    };

    componentWillUnmount() {
        this.favouritesSubscription.unsubscribe();
    }

    componentDidUpdate(prevProps){
        if (this.props.type !== prevProps.type) {
            if (this.formik) this.formik.resetForm();
            this.checkForm();
        }
    }

    get autoplayCampaignId(){
        if(document.querySelector('#form-campaign-id')){
            return document.querySelector('#form-campaign-id').innerText;
        }else{
            return false;
        }
    }
    get autoplayYardType(){
        if(document.querySelector('#form-yard-type')){
            return document.querySelector('#form-yard-type').innerText;
        }else{
            return false;
        }
    }

    get autoplayYardPriority(){
        if(document.querySelector('#form-yard-priority')){
            return document.querySelector('#form-yard-priority').innerText;
        }else{
            return false;
        }
    }

    get isVehicle() {
        return this.props.type === 'make-an-enquiry-specific';
    };

    get overwriteEmail(){
        if(document.querySelector('#overwrite-email')){
            return document.querySelector('#overwrite-email').innerText > 0;
        }else{
            return false;
        }
    }

    get isBrandPage() {
        return this.props.type === 'make-an-enquiry-brand-page';
    };
    get isDealershipsPage() {
        return this.props.type === 'make-an-enquiry-dealerships';
    };

    get isFavourites() {
        return this.props.type === 'make-an-enquiry-favourites';
    };

    get isOfferCard() {
        return this.props.type === 'make-an-enquiry-offer';
    };

    get isNewsCard() {
        return window.is_news === true;
    };

    get isAll(){
        return this.props.type === 'make-an-enquiry-all';
    }


    get isRegisterInterest(){
        return this.props.type === 'register-your-interest';

    };
    get isInsuranceEnquiry(){
        return this.props.type === 'make-an-insurance-enquiry';
    };

    prefillParams = () => {
        if(this.formik) {
            (new URL(window.location.href)).searchParams.forEach((x, y) => {
               if(y === 'dealership'){
                    let newDealership = null;
                    dealershipsGrouped.forEach(group => {
                        if(group.options){
                            group.options.forEach(dealership => {
                                let newString = dealership["label"].toString().replace(/ /g, '');
                                newString = newString.replace(/\W/g, "");

                                if(newString.toLowerCase() === x.toLowerCase()){
                                    let id = dealership["dealer"] ? dealership["dealer"]["ID"] : null
                                    if (id !== this.state.dealership) {
                                        this.setState({formDealerID: id, dealership: dealership["dealer"]['post_title']})
                                    }
                                    if (this.formik) this.formik.setFieldValue('dealership', dealership["dealer"]['post_title']);

                                }

                            });
                        }
                    });


                }else if(y === 'news'){
                   this.setState({
                       news: x
                   })

               }else{
                    this.formik.setFieldValue(y, x)
                }
            });
        }
    }
    findYard = () => {
        return vehicle['@BODY_YARD_SEQ'];
    }
    findMake = () => {
        let vehicleMake = (vehicle['@LISTING_MAKE']);
        let returnValue = false;
        dropDownBrands.forEach(brands => {
            if(brands.options){
                brands.options.forEach(brand => {
                    if(brand['label'] == vehicleMake){
                        returnValue = (brand);
                    }
                })
            }
        })
        return returnValue;

    }
    updateDealers = () => {
        let brandSelected = this.state.selectedBrand || window.current_brand;

        let matchingDealerIDs = [];
        dealershipsGrouped.forEach(region => {
            if(region.options){
                region.options.forEach(dealer => {
                    if(brandSelected){
                        if (dealer.dealer.data['dealership-details'] && dealer.dealer.data['dealership-details'].brand) {
                            if (dealer.dealer.data['dealership-details'].brand.find(br => (br.ID == brandSelected.id))) {
                                matchingDealerIDs.push(dealer.dealer.ID);
                            }
                        }
                        if (dealer.dealer.data['dealership-details'] && dealer.dealer.data['dealership-details']['other-brand']) {
                            if (dealer.dealer.data['dealership-details']['other-brand'].find(br => (br.ID == brandSelected.id))) {
                                matchingDealerIDs.push(dealer.dealer.ID);
                            }
                        }

                    }
                })
            }
        })

        let clonedDealers = JSON.parse(JSON.stringify(dealershipsGrouped))
        clonedDealers.forEach(region => {
            if(region.options){
                let newOptions = [];
                region.options.forEach((dealer, i) => {
                    if (matchingDealerIDs.includes(dealer.dealer.ID)){
                        newOptions.push(region.options[i])
                    }
                })
                region.options = newOptions
            }
        })

        // reset clonedDealers if theres none in there
        let foundDealers = false;
        clonedDealers.forEach(region => {
            if(region.options && region.options.length > 0){
                foundDealers = true;
            }
        })

        if(foundDealers){
            if(brandSelected){
                clonedDealers[0].label = `Select from ${brandSelected.name || brandSelected.label } Dealerships`
            }
        }else{
            clonedDealers = JSON.parse(JSON.stringify(dealershipsGrouped))
        }

        this.setState({dealerships: clonedDealers})
    };

    checkForm = () => {
        const { dealer, brand } = this.props;

        if(this.isBrandPage || this.isOfferCard || this.isNewsCard){
            let offerType = document.querySelector('#offer-type');
            this.updateDealers();
        }

        if (this.isOfferCard || this.isNewsCard) {
            if(currentBrands.length == 1){
                if (this.formik) {
                    if (this.formik) this.formik.setFieldValue('make', dropDownOfferBrands[1].options[0].value);

                }
            }
        } else if(this.isBrandPage){
            if (this.formik) {
                if (this.formik) this.formik.setFieldValue('make', window.current_brand.slug);
            }
        }

        // Preselect dealer
        if (dealer) {
            if (this.formik) this.formik.setFieldValue('dealership', dealer);
            this.setState({ formDealerID: dealer['ID'], dealership: dealer });
        } else {
            this.setState({ formDealerID: null });
        }

        if(vehicle){
            let foundMake = this.findMake();
            if(foundMake){
                if (this.formik) this.formik.setFieldValue('make', foundMake['value']);
                this.setState({ makeID: foundMake['id'], selectedBrand: foundMake }, () => {
                });
            }else{
                if(this.formik) this.formik.setFieldValue('model', vehicle['@LISTING_MAKE']);

            }

            if(this.formik) this.formik.setFieldValue('model', vehicle['@LISTING_MODEL']);
            if (this.formik) this.formik.setFieldValue('stockNumber', window.current_vehicle['@LISTING_STOCK_NO']);



        }
        if(document.querySelector('#form-model-id')){
            // if (this.formik) this.formik.setFieldValue('make', ['value']);
            if (this.formik) this.formik.setFieldValue('make', window.current_brand['slug']);
            this.setState({ makeID: window.current_brand['id'], selectedBrand: window.current_brand }, () => {
            });
            if(this.formik) this.formik.setFieldValue('model', document.querySelector('#form-model-id').innerText);
        }
    };

    handleSubmit = (fields, { setStatus, setSubmitting }) => {
        const { showSuccessPopup, type } = this.props;

        // Reset status, if there where errors
        setStatus();
        let turnstileData = {
            response: this.state.turnstileToken,
        }
        formsService.turnstileVerification(turnstileData).then((response) => {
            if(response.data.success) {
        let data = {
            name: this.isFavourites ? 'Favourites Enquiry' : 'Make An Enquiry',
            fields: JSON.parse(JSON.stringify(fields)),
        };

        if (this.isVehicle) {
            data.vehicle = vehicle ? `${vehicle['@LISTING_SEQ']} (${vehicle['@LISTING_TITLE']})` : null;
            data.dealer = dealer ? `${dealer.data.autoplay.dealer} (${dealer.post_title})` : null;
            data.fields.formDealerID = window.current_dealer['ID'];
            data.fields.stockNumber = vehicle ? `${vehicle['@LISTING_STOCK_NO']}` : null;
            data.fields.make =  vehicle['@LISTING_MAKE'];
            data.fields.model = vehicle['@LISTING_MODEL'];
            data.fields.new = vehicle['@LISTING_NEW'];
            let foundYard = this.findYard();
            if(foundYard){
                data.fields.yard = foundYard;
            }
        }

        if (window.offerTitle) {
            data.fields.offerTitle = window.offerTitle;
        }
        if(currentBrand){
            data.backupBrand = currentBrand;
        }

        if(this.state.news){
            data.fields.news = this.state.news;
        }

        if(this.isRegisterInterest && !data.fields.news){
            data.fields.url = window.location.href;
        }

        if (this.isFavourites) {
            data.favourites = ``;
            for (var key in this.state.favourites) {
                data.favourites += `${this.state.favourites[key].id} `
            }
        }

        if(this.autoplayCampaignId){
            data.fields.autoplayCampaignId = this.autoplayCampaignId;
        }
        if(this.autoplayYardType){
            data.fields.autoplayYardType = this.autoplayYardType;

        }
        if(this.autoplayYardPriority){
            data.fields.autoplayYardPriority = this.autoplayYardPriority;
        }

        if (window.is_careers) {
            data.name = "Careers Page General Enquiry";
        }

        if(this.isRegisterInterest){
            data.name = "Register your interest";
        }

        if(this.isInsuranceEnquiry){
            data.name = "Insurance Enquiry";
        }

        if (this.state.formDealerID) {
            data.fields.formDealerID = this.state.formDealerID;
        }

        if(this.state.news){
            data.fields.news = this.state.news;
        }

        let offerId = document.querySelector('#offer-id');
        if (offerId) {
           data.offerId = offerId.innerText;
        }

        formsService.makeAnEnquiry(data).then(
            success => {
                const title = "Your submission is successful"
                let text = "We will contact you about your enquiry."
                if(this.isRegisterInterest || this.isAll){
                    text = "We will contact you about your enquiry"
                }
                if(window.is_careers){
                    text = "We will contact you about your enquiry";
                }
                showSuccessPopup({ title, text });
                setSubmitting(false);


                let formType = this.props.type;

                if (this.isVehicle) {
                    formType = `make-an-enquiry-${vehicle['@LISTING_SEQ']}`;
                }
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'FormSubmit',
                    'formType': formType,
                    'formBrand': vehicle ? vehicle['@LISTING_MAKE'] : null,
                    'formModel': vehicle ? vehicle['@LISTING_MODEL'] : null,
                    'formRegion': null,
                    'formDealership': data.dealer ? data.dealer : null,
                    'formKm0': vehicle ? vehicle['@LISTING_ODOMETER'] : null,
                    'formVehicleRegistration': vehicle ? vehicle['@LISTING_STOCK_NO'] : null,
                    'phone': data.fields.phone,
                    'email': data.fields.email
                });
            },
            error => {
                setSubmitting(false);
                setStatus(error.message);
            }
        );
            } else{
                setSubmitting(false);
                setStatus("Error with Turnstile Verification");
            }
        });
    };

    renderForm = (props) => {
        const { isValid, isSubmitting, status } = props;
        let makesDisabled = false;
        if(this.isOfferCard || this.isNewsCard) {
            makesDisabled = currentBrands.length == 1
        }else if(this.isBrandPage){
            makesDisabled = true;
        }
        if(currentBrands == false){
            makesDisabled = false;
        }

        let extraClass = 'form-make-an-enquiry';

        if (this.isFavourites) {
            extraClass = `form-make-an-enquiry-favourites`;
        }

        if (this.isVehicle) {
            extraClass = `form-make-an-enquiry-${vehicle['@LISTING_SEQ']}`;
        }


        let formId = '';
        if(this.isInsuranceEnquiry){
            formId = 'insurance-enquires'
        }

        return (
            <Form id={formId} className="popup-form__form">
                {!this.isVehicle &&

                <div className="popup-form__group">

                    <div className="popup-form__label">Vehicle details</div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Select
                                name={`make`}
                                form={props}
                                options={dropDownOfferBrands}
                                onChange={(brand) => {

                                    if (brand.id !== this.state.makeID) {
                                        this.setState({makeID: brand.id})
                                    }

                                    if (brand !== this.state.selectedBrand) {
                                        this.setState({selectedBrand: brand}, () => {
                                            this.updateDealers();
                                        })
                                    }

                                }}
                                isDisabled={makesDisabled || vehicle}
                                modifiers={['form']}
                            />

                        </div>

                        <div className="popup-form__col">

                            <Input
                                name={`model`}
                                placeholder={`Model (optional)`}
                                modifiers={['form']}
                                form={props}
                                disabled={vehicle}
                            />
                        </div>

                    </div>
                </div>
                }
                <div className="popup-form__group">
                    <div className="popup-form__label">Personal details</div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Input
                                name={`firstName`}
                                placeholder={`First Name`}
                                modifiers={['form']}
                                form={props}
                            />
                        </div>
                        <div className="popup-form__col">
                            <Input
                                name={`lastName`}
                                placeholder={`Last Name`}
                                modifiers={['form']}
                                form={props}
                            />
                        </div>
                    </div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Input
                                name={`phone`}
                                placeholder={`Phone`}
                                modifiers={['form']}
                                form={props}
                                type="tel"
                            />
                        </div>
                    </div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Input
                                name={`email`}
                                placeholder={`Email (optional)`}
                                modifiers={['form']}
                                form={props}
                                type="email"
                            />
                        </div>
                    </div>
                </div>

                { !this.isVehicle &&
                    <div className="popup-form__group">
                        <div className="popup-form__label">Dealership</div>
                        <div className="popup-form__row">
                            <div className="popup-form__col">
                                <Select
                                    name={`dealership`}
                                    form={props}
                                    options={this.state.dealerships}
                                    onChange={(dealer) => {
                                        let id = dealer.dealer ? dealer.dealer.ID : null
                                        if (id !== this.state.formDealerID) {
                                            this.setState({ formDealerID: id })
                                        }
                                    }}
                                    isDisabled={(dealer && !(this.isInsuranceEnquiry))}
                                    formatGroupLabel={formatGroupLabel}
                                    modifiers={['form']}
                                />
                            </div>
                        </div>
                    </div>
                }

                <div className="popup-form__group pb-3">
                    <div className="popup-form__label">Your message</div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Textarea
                                name={`message`}
                                placeholder={`Add your message`}
                                form={props}
                            />
                        </div>
                    </div>
                </div>

                {status &&
                    <div className={'popup-form__alert pb-3'}>{status}</div>
                }
                <Turnstile
                    sitekey={process.env.TURNSTILE_SITE_KEY}
                    onVerify={(token) => {
                        this.setState({turnstileToken : token});
                    }}
                    theme={'light'}
                />
                <div className="popup-form__submit">
                    <Button

                        extraClass={extraClass}
                        title={`Submit details`}
                        modifiers={['solid', 'medium']}
                        chevron={true}
                        type="submit"
                        disabled={ !this.state.turnstileToken}
                        loading={isSubmitting}
                    />
                </div>
            </Form>
        );
    }

    render() {
        const { ...rest } = this.props;
        let title = this.isFavourites ? `Ask about your favourites` : `Make an enquiry`;
        if(this.isInsuranceEnquiry){
            title =  `Make an insurance enquiry`;
        }
        const text = `Fill in your details below and we’ll get back to you `;

        const initialValues = {
            firstName: '',
            lastName: '',
            make: '',
            model: '',
            message: '',
            email: '',
            phone: '',
            zapierUrl: window.location.href,

        };

        if(this.isOfferCard || this.isBrandPage || this.isDealershipsPage || this.isAll || this.isNewsCard){
            initialValues.make = '';
            initialValues.model = '';
        }
        initialValues.dealership = '';

        const validationSchema = Yup.object().shape({
            firstName: Yup.string().required('Required'),
            lastName: Yup.string().required('Required'),
            dealership: Yup.string().required('Required'),
            make: (vehicle) ? Yup.string() : Yup.string().required('Required'),
            model: Yup.string(),
            message: this.isOfferCard ? Yup.string() : Yup.string().required('Required'),
            email: Yup.string().email('Invalid email'),
            phone: Yup.string().required('Required'),
        });

        const other = {};

        if (this.isVehicle) {
            other.vehicle = vehicle;
            other.dealer = dealer;
        }

        if(this.isRegisterInterest){
            title = "Register your interest";
        }

        if(this.isInsuranceEnquiry){
            title = "Insurance Enquiry";
        }

        return (
            <Layout
                title={title}
                text={text}
                {...rest}
                {...other}
            >
                <Formik
                    isInitialValid={isInitialValid}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={this.handleSubmit}
                    children={this.renderForm}
                >
                    {formikProps => {
                        this.formik = formikProps;
                        return this.renderForm(formikProps);
                    }}
                </Formik>
            </Layout>
        );
    }
}

export default FormMakeAnEnquiry;
